var ru = {
  pushTip: {
    pushType0: "Загрузка имеет {nums} устройств для которых она уже была выполнена, вы хотите пропустить эти устройства?",
    pushSuccess: "Перейти к описанию задачи чтобы увидеть расписание загрузки?",
    push_all_by_mem: "Загрузить на все каналы операторов: все оборудование под {mem}",
    push_all: "Вы уверены что хотите загрузить на все устройства по всем каналам?",
  },
  app_pushAll: "Загрузит на все терминалы",
  app_uploadApp: 'Загрузить приложение',
  app_No: 'Серийный номер',
  app_terNo: 'Номер терминала',
  app_name: 'Наименование',
  app_appName: 'Наименование приложения',
  app_appType: 'Тип приложения',
  app_insType: 'Тип установки',
  app_vStatus: 'Статус',
  app_ulTime: 'Время загрузки',
  app_appLoding: 'Приложение загружается',
  app_newgVer: 'Последняя версия',
  app_operate: 'Операция',
  app_type: 'Тип',
  app_del: 'Удалить',
  app_pause: 'Пауза',
  app_continue: 'Продолжить',
  app_status: 'Статус',
  app_new: 'Добавить',
  app_yes: 'Да',
  app_no: 'Нет',
  app_selectAll: 'Выбрать все',
  app_save: 'Сохранить',
  app_process: 'Process',
  app_push: 'Push',
  app_terminal: 'Терминал',
  app_to: ' на ',
  app_offShelf: 'Удалить',
  app_mulOffShelf: 'Пакетное удаление',
  app_isOffShelf: 'Вы хотите удалить приложение из магазина приложений?',
  app_isDelApp: 'Вы хотите удалить приложение?',
  app_chooseOneMust: 'Выберите хотя бы одно прилжение',
  app_cantDelTask: 'Выбранные задачи не могут быть удалены',
  app_oneRecordMust: 'Выберите хотя бы одну запись',
  app_phoneIllegal: 'Недействительный номер телефона',
  app_groupName: 'Имя категории',
  app_sure: 'Да',
  app_query: 'Запрос',
  app_reset: 'Сброс',
  app_cancel: 'Отмена',
  app_edit: 'Редактирование',
  app_add: 'Добавить',
  app_verify: 'Проверить',
  app_isPass: 'Результат',
  app_pass: 'Одобрено',
  app_ban: 'Отклонено',
  app_noInput: 'Не заполнено',
  app_banReason: 'Причина отказа',
  app_filter: 'Фильтр',
  app_prePushVerify: 'Ожидание поддтверждения',
  app_preVerify: 'ожидание проверки',
  app_verifyPass: 'Утверждено',
  app_verifyNotPass: 'Отказано',
  app_success: 'Успешно',
  app_submit: 'Отправить',
  app_tip: 'Подсказка',
  app_online: 'На линии',
  app_offline: 'Отключен',
  app_fileOver: 'Файл закончился',
  app_onlyApk: 'Загрузка только файлов Apk',
  app_onlyApk_2: 'Загрузка только файлов Apk/Hap',
  app_tipViewTask: 'Успешная загрузка, пожалуйста, отслеживайте прогресс в менеджере задач',
  app_tipMkDel: 'Приложение в магазине приложений будет удалено синхронно. Вы хотите удалить?',
  app_tipAppEdit: 'Восстановление невозможно, вы хотите удалить?',
  app_tipVerify: 'Вы действительно хотите отправить?',
  app_rqsError: 'Ошибка запроса',
  app_not_auth: 'TMS не активирован',
  app_mulAdd: 'Пакетное добавление',
  app_select: 'Выберите',
  app_input: 'Пожалуйста, введите содержимое',
  app_inputCp: 'Пожалуйста, заполните',
  app_inputName: 'Пожалуйста, введите наименование',
  app_inputContact: 'Пожалуйста, введите контактное лицо',
  app_inputTruePhone: 'Пожалуйста, введите правильный номер телефона',
  app_inputAddr: 'Пожалуйста, введите адрес',
  app_inputVer: 'Пожалуйста, введите версию',
  app_inputVerTag: 'Пожалуйста, введите код версии',
  app_inputID: 'Введите идентификацию',
  app_inputPkg: 'Пожалуйста, введите имя пакета',
  app_noVerTag: 'Нет кода версии',
  app_inputIntrol: 'Пожалуйта, введите описание',
  app_selectType: 'Пожалуйста, выберите тип приложения',
  app_ulApp: 'Пожалуйста, загрузите файл приложения',
  app_ulIcon: 'Пожалуйста, загрузите маленькую иконку',
  app_ulLarIcon: 'Пожалуйста, загрузите большую иконку',
  app_ulScreenShot: 'Пожалуйста, загрузите снимки экрана',
  app_smVerify: 'Отправить',
  app_baseInfo: 'Базовая информация',
  app_version: 'Версия',
  app_autoUpload: 'Автоматическая загрузка',
  app_verTag: 'Код версии',
  app_ID: 'Идентификация',
  app_package: 'Имя пакета приложения',
  app_introl: 'Краткое описание приложения',
  app_udState: 'Описание обновления',
  app_icon: 'Маленькая иконка приложения',
  app_larIcon: 'Большая иконка приложения',
  app_screenShot: 'Снимки экранов приложения',
  app_appVer: 'Версия приложения',
  app_createTime: 'Дата создания',
  app_close: 'Закрыть',
  app_ulNew: 'Загрузить последюю версию',
  app_selectApp: 'Выберите приложение',
  app_testInstall: 'Проверка установки',
  app_ulAppState: 'Перетащите файлу сюда, или нажмите Загрузить, поддерживаются только файлы apk',
  app_clickUpdate: 'Нажмите загрузить',
  app_udType: 'Способ обновления',
  app_allUpdate: 'Обновить все',
  app_iconState: '144x144, Размер не должен превышать 100k',
  app_larIconState: '512x512, Размер не должен превышать200k',
  app_autoInstall: 'Автоматическая установка',
  app_addApp: 'Добавить приложение',
  app_classIntrol: 'Рекомендуемая категория',
  app_homeIntrol: 'Рекомендуемая главная',
  app_isIntroClass: 'Рекомендовать ли классификацию',
  app_isIntroHome: 'Рекомендовать ли главную',
  app_isUnbindApp: 'Вы уверены, что хотите отвязать приложение？',
  app_isOffApp: 'Вы уверены, что хотите отложить приложение?',
  app_isDelData: 'Вы уверены, что хотите удалить эти данные?',
  app_inputAName: 'Пожалуйста, введите наименование',
  app_oneDeviceMust: 'Выберите хотя бы одно устройство',
  app_fileSize: 'Размер файла',
  app_addPush: 'Добавить загрузку',
  app_viewPushHis: 'Посмотреть историю загрузок',
  app_pushTimes: 'Время загрузки',
  app_hisVer: 'Историческая версия',
  app_pushHistory: 'История загрузки',
  app_pushInstall: 'Загрузка инсталлятора',
  app_animatePush: 'Загрузка анимации',
  app_animateMake: 'Пользовательская анимация',
  app_pushDevice: 'Устройство для загрузки',
  app_deviceNum: 'Количество устройств',
  app_deviceName: 'Наименование устройства',
  app_deviceNo: 'Номер устройства',
  app_pushTime: 'Время загрузки',
  app_distributor: 'Торговая организация',
  app_dParent: 'Родительская торговая организация',
  app_unbind: 'Удалить',
  app_mulUnbind: 'Пакетное удалени',
  app_mulPush: 'Пакетная загрузка',
  app_searchTerminal: 'Найти устройства',
  app_terName: 'Имя терминала',
  app_taskName: 'Имя задачи',
  app_taskDetail: 'Содержимое задачи',
  app_deviceTotal: 'Общее число устройств',
  app_downloading: 'Скачиваем',
  app_downFail: 'Ошибка скачиваения',
  app_update: 'Обновить',
  app_md5Fail: 'Ошибка проверки MD5',
  app_theNewgVer: 'последняя версия уже установлена',
  app_fileFmIllegal: 'Неправильный формат файла',
  app_updateFail: 'Ошибка обновления',
  app_usrCancelUpdate: 'Пользователь отменил обновление',
  app_pushFail: 'Устройство отключено от сети',
  app_downFinish: 'Загрузка завершена',
  app_updateSuccess: 'Обновление выполнено успешно',
  app_fail: 'Ошибка',
  app_addres: 'Адрес',
  app_mulDel: 'Пакетное удаление',
  app_contact: 'Контактное лицо',
  app_contactPhone: 'контактный номер',
  app_typeName: 'Наименование типа',
  app_customs: 'Пользовательская модель',
  app_clear: 'Очистить',
  app_customsTime: 'Пользовательское имя',
  app_launchAnimate: 'Анимация включения',
  app_onLogo: 'Начальные логотип',
  app_animateName: 'Имя анимации',
  app_playPlace: 'Позиция востроизведения',
  app_aSrcFile: 'Файл ресурса анимации',
  app_asfState: 'Анимированная картинка, Помните, что имя файла должно быть part0.zip',
  app_downExp: 'Пример загрузки',
  app_ologoState: 'Экран, отображаемый после завершения воспроизведения',
  app_picSize: 'Размер изображения',
  app_picSizeState: 'Введите высоту*ширину',
  app_frame: 'Число кадров',
  app_frameState: 'Число кадров в секунду',
  app_aCycleTime: 'Число повторов анимации',
  app_cyclePlay: 'Зацикленное воспроизведение',
  app_playOnce: 'Проиграть один раз',
  app_fileNameOnly: 'Имя файла должно быть',
  app_inputNumber: 'Пожалуйста, введите номер',
  app_picUlError: 'Ошибка загрузки изображения',
  app_inputAnimateName: 'Пожалуйста, введите наименование анимации',
  app_selectAnimateType: 'Пожалуйста, выберите тип анимации',
  app_selectPlayPlace: 'Пожалуйста, выберите позицию воспроизведения',
  app_uploadAnimateFile: 'Пожалуйста, загрузите файл анимации',
  app_uploadOnPic: 'Пожалуйста, загрузите начальный логотип',
  app_sureDelTip: 'Вы уверены что хотите удалить? Восстановление невозможно',
  app_uploadPic: 'Пожалуйста, загрузите картинку',
  app_launchUI: 'Начальный интерфейс',
  app_amechine: '',
  app_chooseCycleType: 'Пожалуйста, выберите режим повтора',
  app_formatNotTrueLike: 'Неправильный формат',
  app_on: 'Включено',
  app_off: 'Выключено',
  app_onOff: 'Включено или выключено',
  app_firm: 'Имя производителя',
  // 2017-7-28 wei add
  add_srcFwByName: 'Найти прошивку по имени',
  app_downNum: 'Количество скачиваний',
  app_pushed: 'Выпущено',
  app_notPass: 'Отклонено',
  app_sysType: 'Тип системы',
  app_sys: 'Система',
  app_sysUdPack: 'Пакет обновления системы',
  app_chooseFile: 'Выберите файл',
  app_signCer: 'Сертификат подписи',
  app_isUseDisCerAutoSign: 'Использовать сертификат торговой организации для автоматической подписи',
  app_useDis: 'Назначенная торговая организация',
  app_allDisUsed: 'Общая для всех торговых организаций',
  app_pushInstallTest: 'Проверить загрузку инсталлятора',
  app_firmware: 'Имя прошивки',
  app_pushType: 'Тип загрузки',
  app_dv: 'Устройство',
  // 2017-7-31 wei add
  app_fwType: 'Тип прошивки',
  app_ulNormalSt: 'Перетащите файл сюда или нажмите загрузить',
  app_selectChannel:'Пожалуйста, выберите торговую организацию',
  app_isSubmitToCheck: 'Отправить на проверку',
  app_pleaseInputNo: 'Пожалуйста, введите номер терминала',
  app_cnAndActive: 'Онлайн-активация',
  app_clearCer: 'Очистить сертификат',
  app_ofCheck: 'Проверка',
  app_normal: 'Нормально',
  app_netStatus:  'Статус сети',
  app_active:'Активировано',
  app_initiative: 'инициатива',
  app_selfDestroy:  'Саморазрушение',
  app_mulActive:  'Активно в пакете',
  app_selected:'Выбрано',
  app_cerCheckOf:'Переключатель проверки',
  app_openCerCheck: 'Проверка включена',
  app_closeCerCheck: 'Проверка отключена',
  app_reOpen: 'Открыть повторно',
  app_reClose:  'Зактрыть повтоно',
  app_open:  'Открыть',
  app_usrManage:  'Управление пользователями',
  app_stManage: 'Управление конфигурациями',
  app_roleManage: 'Управление ролями',
  // 2017-8-8 wei add
  app_cerMgType: 'Тип управления сертификатом',
  app_cerMgSelf:  'Сертификат самоуправления',
  app_cerMgOther: 'Сертификат платформы',
  app_cerMgCustomer: 'Индивидуальные',
  app_operateHis:'История операций',
  app_operateType:'Тип операции',
  app_time:'Время',
  app_isActive: 'Активность',
  // 2017-8-8 wei add
  app_downCer: 'Скачать сертификат',
// 2017-8-10 wei add
  app_isOperate: 'Продолжить?',
  // 2017-8-11 wei add
  app_ulSuccess:'Успешная загрузка',
// 2017-7-31 wei add
  app_setting:'Настройка',
// 2017-8-15 wei add
  app_clickPicToUlPic:'Нажмите для загрузки изображения',
  app_within: 'в',
  app_pgsFormat: 'Формат(png, gif, svg)',
  app_sgUseAndAdUse: 'Формат:svg, рекомендуем белый цвет',
  app_sureChange: 'Подтвердите изменения',
  app_logoLvTip: 'Выйти без сохранения?',
  app_dfIcon: 'Икона по-умолчанию',
// 2017-8-16 wei add
  app_useBigSize: 'Большой размер',
  app_useBigSizeTip: 'Нажмите для оптимизации вида',
  // 2017-8-22 wei add
  app_or: 'Или',
  app_format: 'Формат',
  app_pic: 'Картинка',
  app_s: " (и)",
  app_plsUpl: 'Пожалуйста, Загрузите',
  // 2017-8-24
  app_upload:'Загрузите',
  app_cerType:'Тип сертификата',
  // 2017-8-31
  app_editProfile: 'Редактировать профиль',
  // 2017-9-1
  app_cerFile: 'Файлы сертификата',
  app_plsUlPbCer: 'Пожалуйста, загрузите сертификата',
  app_appNoCerTip: 'Текущий канал с сертификатом самоуправления, пожалуйста, загрузите файл публичного ключа для проверки приложений',
  app_appNeedCerTip: 'Текущий канал не имеет сертификата, пожалуйста, свяжитесь с администратором платформы для создания',
  app_createCer: 'Создать серфикат',
  app_uploadCer: 'Загрузить сертификат',
  app_ustart: 'Не начал дейстовать',
  app_outofdate: 'Истек',
  // 2017-9-4
  app_fileImport: 'Импорт файла',
  app_mdFile: 'Файл шаблона',
  app_down: 'Скачать',
  // 2017-9-5
  app_roleAllot: 'Назначени роли',
  app_roleName: 'Роль',
  app_downTplFile: 'Скачать файлы шаблонов',
  // 2017-9-7
  app_verUdCt: 'Содержимое обновления версии',
  app_animation: 'анимация',
  app_per: 'на',
  app_minute: 'минуту',
  app_autoRefresh: 'авто-обновление',
  app_level: 'уровень',
  app_firm: 'фирма',
  app_model: 'модель',
  app_adType: 'Тип рекламы',
  app_license: 'ключ лицензии',
  app_maintain: 'поддержка',
  app_manage: 'управление',
  app_is: 'это',
  app_plsip: 'пожалуйста, введите',
  app_reason: 'причина',
  //2017 9-26
  app_sgMc: 'одна машина',
  app_ss: 'обзор',
  app_inst: 'установить',
  app_file: 'файл',
  app_printscreen: 'печать экрана',
  app_batch: 'пакет',
  app_recov: 'восстановление',
  app_lc: 'загрузчик',
  // 2017 10-11
  app_re: 'снова',
  app_confirm: 'подтвердить',
  app_df: 'по-умолчанию',
  app_as: 'как',
  app_click: 'нажмите',
  app_content: 'содержимое',
  app_ttPkg: 'весь пакет',
  app_dfPkg: 'пакет различий',
  app_task: 'задача',
  app_catch: 'хватать',
  app_log: 'Лог',
  app_continued: 'продолжение',
  app_sec: 'секунда',
  app_video: 'видео',
  app_ad: 'реклама',
  // 2017 10-25
  app_choose: 'выберите',
  app_timeInterval: 'интервал времени',
  app_and: 'и',
  app_play: 'воспроизвести',
  app_times: 'раз',
  app_sc: 'секунда',
  app_tofvalis: 'Условия валидности',
  app_tofvaliss: 'Условия валидности',
  app_start: 'начало',
  app_end: 'конец',
  app_preview: 'предварительный просмотр',
  app_duration: 'продолжительность',
  app_size: 'размер',
  app_personnel: 'работник',
  app_cannot: 'не может',
  app_early: 'раньше',
  app_later: 'позже',
  app_lessThan: 'меньше чем',
  app_moreThan: 'больше чем',
  // 2017 11-14
  app_nums: 'числа',
  app_waiting: 'ожидание',
  app_all: 'все',
  app_all1: 'все',
  app_thistime: 'в этот раз',
  app_done: 'сделано',
  app_areyou: 'Вы',
  app_skip: 'пропустить',
  app_these: 'эти',
  app_cover: 'обложки',
  app_jump: 'перейти',
  app_detail: 'подробности',
  app_view: 'просмотр',
  app_now: 'сейчас',
  app_imp: 'импортировать',
  app_size1: 'размер',
  app_taskMg: 'Управление задачами',
  app_taskType: 'Тип задачи',
  app_cancelPush: 'Отменить загрузку',
  app_azcgsj: 'время успешной установки',
  app_ispushf: 'Загрузка файла',
  app_autoscopen: 'Установка выполнена успешно и откроется автоматически',
  app_pushsctipinstall: 'Нажмите, чтобы загрузить пробную версию приложения',
  app_tipdown: 'Подскажка скачивания',
  app_tipud: 'Подсказка обновления',
  app_sysinfo: 'Системная информация',
  app_bth: 'На главную',
  app_terstatus: 'Статус терминала',
  app_fminfo: 'Информация о прошивке',
  app_norightview: 'Вы не имеете доступа к этой странице',
  // 2017 11-27
  app_fault: 'сбой',
  app_geo: 'география',
  app_abnormal: 'ненормальное',
  app_blockp: 'Замятие бумаги',
  app_ecr: 'Электрический считыватель карт',
  app_mcr: 'Ручной считыватель карт',
  app_nacr: 'Считыватель карт недоступен',
  app_cardr: 'Считыватель карт',
  app_rcmsg: 'Получено сообщение',
  app_tgcr: 'Считыватель карт второго поколения',
  app_receiptp: 'Принтер чеков',
  app_hbsp: 'Интервал опроса',
  app_checkupsp: 'Интервал проверки обновлений',
  app_ispushalldv: 'Загрузить на все устройства',
  //edit lin
  lin_btn:{
    cancel: "Отмена",
    add: "Добавить",
    install:'установка',
    batch_install:'Пакетная установка',
    tips:'Подсказка',
    confirm:'Подтвердите',
    unbind:'Отвязать',
    unbindAll:'Пакетная отвязка',
    check:'Запрос',
    reset:'Сброс',
    submit:'Отправить',
    restart:'Перезапустить',
    off:'Закрыть',
    send:'Отправить',
    batch_delete:'Пакетное удаление',
    delete:'Удалить',
    lock:'Заблокировать',
    lockOta:'Заблокировать OTA',
    add_zeng:'Добавить',
    edit:'Изменить',
    save:'Сохранить',
    bind:'Привязать',
    //20170727新增edit by linziying
    bindAll:'Пакетная привязка',
    xiezai:'Удалить',
    unlock:'Разблокировать',
    change:'Изменить',

  },
  lin_global:{
    cs_config: 'Настройка параметра',
    task_tips:'Установка выполнена успешно, пожалуйста, отслеживайте процесс загрузки в Менеджере задач',
    task_tips2:'Загрузка выполнена успешно，пожалуйста, отслеживайте прогресс в Менеджере задач',
    ope:'Операция',
    pselect:'Пожалуйста, выберите',
    label_no:'Серийный номер',
    loading:'Загружаем',
    label_name:'Имя',
    all_mechanism:'Все торговые организации',
    place_areaid:'Пожалуйста, выберите торговую организацию',
    time:'Время',
    version:'Версия',
    name:'Имя',
    remark:'Пометка',
    edit:'Изменить',
    label_model:'Модель устройства',
    label_type:'Тип устпройства',
	device_type_1:"Умные позы.",
	device_type_2:"Остальное оборудование.",
    label_manufid:'Производитель',
    label_areaid:'Торговая организация',
    label_areaid_name:'Наименование торговой организации',
    label_address:'Адрес',
    ter_status:'Статус',
	dest_status:'Режим самоуничтожения',
    net_status:'Сеть',
    run_status:'Оборудование',
    online:'Подключено',
    offline:'Отключено',
    new_add:'Добавить',
    normal:'Нормально',
    marn:'Предупреждение',
    fault:'Сбой',
    success_tips:'Успешная операция',
    concel_tips:'Отменена',
    zlxfs_tips:'Ордер был выписан успешно',
    sb_tips:'Сбой выполнения, отсутствует связь с терминалом',
    czsb:'Сбой выполнения',
    zl_error:'Ошибка создания операции',
    all_status:'Все статусы',
    delete_success:'Успешное удаление',
    look_detail:'Посмотреть подробности',
    ter_num:'Качество устройства',
    ota_bao:'Пакет OTA',
    ple_sel_ota:'Пожалуйста, выберите пакет OTA',
    unlock_success:'Разблокировка выполнена успешно',
    risk_name:'Имя подтверждения',
    risk_type:'Тип предупреждения',
    risk_radius:'Диаметр ограждения (км)',
    risk_city:'Создание коммуникатора ',
    risk_desc:'Описание',
    risk_warn_info:'Информация о предупреждении управления рисками',
    warn_event:'Событие предупреждения',
    city:'Город',
    jwd:'Широта и долгота',
    distance:'За пределами установленной дистанции (км)',
    ccwl:'За ограждением',
    sbyj:'Предупреждение устройства',
    done:'Сделано',
    undone:'Не обрабатывается',
    roles_tips:'Пожалуйста, выберите роль',
    roles_place:'Прозвище',
    userName:'Имя пользователя',
    nickName:'Прозвище',
    phoneNum:'Мобильный номер',
    roleName:'Роль',
    jh:'Активировать ',
    dj:'Заморозить',
    phoneNum2:'Сотовый номер',
    resetPass:'Сбросить пароль',
    revisePass:'Изменить пароль',
    oldPass:'Старый пароль',
    newPass:'Новый пароль',
    comfirmPass:'Подтвердите новый пароль',
    plePassTips:'Пожалуйста, введите пароль',
    plePassTipsAgain:'Пожалуйста, введите пароль снова',
    pwdDisfault:'Два пароля не совпадают',
    unfitPhone:'Номер телефона не существует',
    nickNameTips:'Прозвище не может быть пустым',
    userNameTips:'Имя пользователя не может быть пустым',
    phoneNumTips:'Номер телефона не может быть пустым',
    roleidTips:'Роль не может быть пустой',
    mechanismIdTips:'Торговая организация не может быть пустой',
    userStatusTips:'Пожалуйста, установите статус пользователя',
    editPage:'Изменить страницу',
    addPage:'Добавить страницу',
    status:'Статус',
    refs:'Пожалуйста, уточните информацию',
    user:'Пользователь',
    logStartTime:'Начало лога',
    logEndTime:'Конец лога',
    download:'Скачать',
    ddsc:'Ожидание загрузки',
    scz:'Загружаем',
    scsb:'Сбой загрузки',
    sccg:'Загрузка выполнена успешно',
    rz_tips:'Логи получены успешно. Пожалуйста, отслеживайте прогресс в Управлении логами',
    hqrz:'Получить логи',
    logoTitle:'Система Управления Терминалами',
    hello:'Здравствуйте',
    wdzl:'Ваш профиль',
    tcxt:'Выйти',
    yhdl:'Войти',
    zh:'Учентая запись',
    password:'Пароль',
    jzmm:'Напомнить пароль',
    login:'Войти',
    bah:' © 1993 - 2020 Авторское право все кантоны ип 12035887 ',
    qsrzh:'Пожалуйста, введите имя пользователя',
    qsrmm:'Пожалуйста, введите пароль',
    error:'Ошибка',
    wlzt:'Статус сети',
    ckxq:'Посмотреть подробности',
    wlmc:'Имя ограждения',
    wllx:'Тип ограждения',
    bdsb:'Привязать устройство',
    tjbd:'Добавить привязку',
    bjwl:'Изменить ограждение',
    wxzyjlx:'Пожалуйста, выберите тип предупреждения',
    cityName:'Название города',
    sfjxpljb:'Пакетное отвязывание или нет',
    qxzyjbdzd:'Пожалуйста, выберите терминал для отвязывания',
    jbcg:'Отвязывание выполнено успешно',
    sfjbczd:'Отвязвать этот терминал или нет',
    sfjxplbd:'Пакетное отвязывание или нет',
    qxzybddzd:'Пожалуйста, выберите терминал для привязки',
    bdcg:'Привязка выполнена успешно',
    sfbdczd:'Привязать этот терминал или нет',
    xzwl:'Добавить ограждение',
    qdxysccwl:'Вы уверены, что хотите удалить это ограждение?',
    tsazcs:'Проверка загрузки установки',
    shzt:'статус',
    pass: "Подтверждено",
    notPass: "Отклонено",
    waitOne: "Ожидание отправки",
    waitTwo: "Ожидание рассмотрения",
    shyy:'Причина отказа',
    zdtslb:'Список терминалов для загрузки',
    xztghbtg:'Передать или нет',
    qrtj:'Подтвердите передачу',
    shcg:"Рассмотрено успешно",
    syqdsty:'Общее для всех торговых сетей',
    notBlankName: "Имя не может быть пустым",
    notBlankVer:'Версия не может быть пустой',
    qxzlx:'Пожалуйста, выберите тип',
    qxzscwj:'Пожалуйста, выберите файл для загрузки',
    zdqds:'Назначенная торговая организация',
    sfsyzdqm:'Использовать сертификат канала торговой организации для автоматической подписи',
    qmzst:'Сертификат подписи',
    azbdz:'Адрес пакета установки',
    qscapkwj:'Пожалуйста, загрузите файл apk, не более 50M',
    qsczipwjls50:'Пожалуйста, загрузите файл zip, не более 50M',
    jwjtdcc:'Перетяните файл сюда или',
    djsc:'Нажмите загрузить',
    xgscwj:'Изменить загружаемый файл',
    otaName:'Имя',
    xtlx:'Тип системы',
    syatemR:'Системый ROM',
    sysjota:'Системное пакетное обновление OTA',
    waitOne: "Ожидание отправки",
    waitTwo: "Ожидание рассмотрения",
    verifyPass: 'Подтверждено',
    verifyNotPass: 'Отклонено',
    confirmDelete: "Вы уверены в удалении？",
    tjshcg:'Успешная отправка',
    qdtjsh:'Подтвержите отправку',
    allType:'Все типы',
    smVerify: 'Отпарвка подтверждена',
    downNumber:'Количество скачиваний',
    tgmccz:'Найти по имени',
    upload:'Загрузить',
    xzqddhwj:'Выберите файл анимации при запуке',
    qxzkjlogo:'Выберите начальный логотип',
    tpxzds:'300x300 наилучший размер для картинки, размер не более 2М',
    zmlaun:'Выберите пользовательскую среду запуска приложений',
    xtjcb:'Выберите базовый системынй пакет',
    null:'Пусто',
    shebei:'Устройство',
    tslxxx:'Тип загрузки',
    xzbbbbb:'Выберите пакет OTA',
    uploadTime: "Время загрузки",
    verTips:'на основе этой  версии  создания  дифференцированного  пакет  ,  номер версии  не  с  V  или  version  и других персонажей  ,  чисто цифровой  2.2.4  , таких, как  : ',
    verTips1:'номер версии  не  с  V  или  version  и других персонажей  ,  чисто цифровой  2.2.4  , таких, как  : ',
    bbhgsbd:'Неправильный формат версии',
    lkymtips:'Идет загрузка файлов, вы действительно хотите покинуть эту страницу',
    znscziptips:'Загрузка только файлов Zip',
    qsczipwj:'Пожалуйста, загрузите файлы Zip',
    //20170727新增edit by linziying
    danweikm:'Единицы км',
    weilanshuoming:'Описание: Широта и долгота последних известный координат устройства это центр ограждения',
    pleaseUpload:'Пожалуйста, загрузите',
    zdqmTips:'Автоматически подписывать сертификат поставщика канала',
    zhidingqdsxx:'Информация о назначенной торговой организации',
    selectWenjian:'Выберите файл',
    qrjxmm:'Вы уверены, что выполнили эту команду: ',
    cicaozuo:'Операция?',
    shebeiedit:'Редактировть устройство',
    yxpztitle:'Настройка почтового ящика',
    yjyouxiang:'Почтовый ящик для оповещений',
    chongzhi:'Сбросить',
    ljchangjian:'Потдтвердить',
    ympeizhi:'Настрока имени домена',
    fwqdizhi:'Адрес сервера',
    fwqdztips:'Адрес не должен содержать символы "http: //", и может быть или доменным именем или IP адресом, например: www.baidu.com or 127.0.0.1',
    fwqduankou:'Порт сервера',
    duankoutips:'Не добавляйте ":" к номеру порта, просто введите: 8080',
    tuisongpeizhi:'Загрузить конфигурацию',
    tuisongjl:'Загрузить запись',
    tuisonglx:'Тип загрузки',
    chenggong:'Успешно',
    shibai:"Ошибка",
    tuisongtime:'Время загрузки',
    chongtui:'Загрузить снова',
    shebeibei:'Устройство',
    fwqdzbnwk:'Адрес сервера не может быть пустым',
    fwqdkhbnwk:'Номер порта сервера не может быть пустым',
    wdct:'Вы уверены, что хотите загрузить снова',
    tuisongtips:'Вы действительно хотите загрузить настройку доменого имени? Изменения вступят в силу после успешной перезагрузки',
    //20170731 lin add
    china:'Китайский',
    english:'Английский',
    russian: 'Русский',
//20170804 lin add
    cjzs:'Создать сертификат',
    createTime:'Время создания',
    certificateName:'Имя сетрификата',
    xiafa:'Загрузить',
    dachuzhengshu:'Сохранить сертификат',
    guojia:'Страна',
    shengfen:'Регион',
    gongsi:'Компания',
    youxiang:'Email',
    youxiaoqi:'Дата истечения',
    certTypeLabel: 'Тип сертификата',
    certForManufacturer: 'производитель',
    certForCustomer: 'клиент',
    danweitian:'Единицы: День',
    xinjian:'Новый',
    notNull:'Должен',
    bitian:'Должен',
    guojiatips:'Сокращение страны',
    shenfentips:'Регион(ENG/CHN)',
    cityTips:' Город(ENG/CHN)',
    gongsiTips:'Компания(ENG/CHN)',
    emailTips:'Email',
    youxiaoqiTips:'Дата истечения, в днях',
    xuantian:'Не обязательный',
    srgsbzq:' Неправильный формат',
    cszss:'SZZT сертификат',
    khzss:'Серитфикат дистрибьютора',
    sccszss:'Загрузить сертификат SZZT',
    zhengshu:'Сертификат',
    qudaoshangxinxi:'механизм',
    quorter:'Пожалуйста, подтвердите дистрибьютора или SN',
    xiafalishi:'Скачать запись',
    resXiafa:'Скачать повторно',
    chongxintuisong:'Загрузить повторно',
    tuisongleixing:'Как загрузить',
    dachusiyao:'Сохраните секретный ключ',
    shuaxin:'Обновить',
    passWordTips:'Требуется пароль',
//20170804 lin add end
//20170821 lin add
    daochugongyao:'Экспорт сертификатов',
    //20170821 lin add end
    //20170822 lin add
    zhengshuType:'Тип сертификата торговой организации',
    ziguan:'Самоуправляемый',
    daiguan:'Управляемый платформой',
    //20171023 add by sing
    add_merchant: 'Добавить торговую организацию'

  },
  //edit lin
  terminal: {
    //添加设备 Добавить устройства

    add:{
      //label值 Label value
      //放在global Place it on global

      //placeholder值 placeholder value
      place_no:"Пожалуйста, введите номер устройства",
      place_name:'Пожалуйста, введите имя устройства',
      place_model:'Пожалуйста, выберите модель устройства',    //also rules
      place_type:'Пожалуйста, выберите тип устройства',     //also rules
      place_manufid:'Пожалуйста, выберите производителя',      //also rules
      //also rules
      place_address:'Пожалуйста, введите адрес устройства',  //also rules
      place_actime:'Введите время активации устройства',  //also rules
      place_extime:'Введите время истечения срока действия устройства',  //also rules
      //popover值 popover value
      popover_no:'Номер устройства должен состоять из букв, цифр или символа подчеркивания, общая длина не более 50 символов',
      popover_name:'Имя устройства должно состоять из букв, цифр или символа подчеркивания, общая длина не более 50 символов',
      //校验规则 Check rules
      rules_no_1:'Номер устройства не может быть пустым',
      rules_no_2:'Номер устройства не может быть больше 20 символов',
      rules_no_3:'Номер устройства должен состоять из букв, цифр или подчеркивания',
      rules_no_4:'Номер устройства уже существует',
      rules_name_1:'Имя устройства не может быть пустым',
      rules_name_2:'Имя устройства не может быть больше 20 символов',
      rules_name_3:'Имя устройства должен состоять из букв, цифр или подчеркивания',
      //提交弹出提示Submit pop-up prompt
      success:'Добавлено успешно',
      change_success:'Изменено успешно',


    },
    appBind:{
      label_name:'Имя приложения',
      label_version:'Номер версии',
      label_size:'Размер приложения',
      place_name:'Поиск по имени',
      place_terminal:'Пожалуйста, выберите терминал',
      empty_tips:'Пожалуйста, выберите приолжение для привязки!',
      install_tips:'Вы уверены, что хотите установить это приложение?',
      five_tips:'Связанных приложений не может быть больше 5',

    },
    appList:{
      label_name:'Имя приложения',
      label_type:'Тип приложения',
      label_version:'Номер версии',
      label_time:'Время привязки',
      format_status1:'Общее приложение',
      format_status2:'Системное приложение',
      tips1:'Вы уверены, что хотите удалить это приложение?',
      tips2:'Отвязка выполнена успешно',

    },
    appLog:{
      start_time:'Время начала',
      end_time:'Время окончания',
      log_type:'Тип лога',
      log_content:'Содержимое лога',


      num:'Число устройств',
      tower:'',

    },
    details:{
      regain:'Сброс',
      run_log:'Текущий лог',
      risk_info:'Информация об управлении рисками',
      app_list:'Список приложений',
      app_install:'Установить приложение',
      send_animate:'Загрузить анимацию',
      reset_animate:'Восстановить анимацию',
      base_info:'Базовая информация',
      system_info:'Системные сообщения',
      launcher:'версия загрузчика',
      system_version:'Версия системы',
	  system_spversion:'Версия чипа безопасности',
      ota_version:'Версия OTA',
      hard_version:'Версия прошивки',
      last_time:'Последнее обновление',
      net_type:'Тип сети',
      online_time:'Время в сети',
      run_time:'Время работы',
      hard_info:'Информация об оборудовании',
	  Electric_quantity:"электричеств",
	  network:"сет",
      cpu:'Информация о процессоре',
      mem:'Информация о памяти',
      cpuUsed:'Использование процессора',
      memUsed:'Использование памяти',
      hydh:'Восстановить анимацию',
      tips:'Пожалуйста, выберите тип анимации для восстановления',
      kjdh:'Начальная анимация',
      gjdh:'Анимация при выключении',
      kjlogo:'Загрузочный логотип',
      alldhlogo:'Все (анимация и логотип）',
      zbhy:'Временно не восстанавливать',
      mshy:'Восстановить немедленно',
      tsdh_title:'Загрузить анимацию',
      animate_name:'Имя анимации',
      animatType:'Тип',
      position:'Позиция воспроизведения',
      createTime:'Время пользователя',
      animate:'Анимация',
      kjlogo:'Загрузочный логотип',
      kj:'Включено',
      gj:'Выключено',
      kgj:'Включено или выключено',
      com_send: 'Подтвердить загрузку',
      cover_send: 'Покрытие загрузки',
      skip_send: 'Пропустить загрузку',
      comfirm_send:'Загрузить эту анимацию',
      comfirm_hy:'Восстановить эту анимацию?',
      hy_success:'Восстановлено успешно',
      hy_type:'Пожалуйста, выберите тип анимации для восстановления',
      open_abd:'Открыть ADB',
      close_abd:'Закрыть ADB',
      if_ope:'Сделать или нет',

    },
    list:{
      add_btn:'Добавить',
      import_btn:'Импортировать',
      ztgxsj:'Последнее обновление',
	  ac_time:"Время активации ТМS",
	  ec_time:"Срок годности",
      import_title:'Импортировать информацию об устройстве',
      xqwj:'Выберите файл',
      qrdr:'Вы уверены, что хотите импортировать?',
      import_muban:'Скачать шаблон документа для импорта',
      notify_title:'Результаты импорта',
      delete_tips:'Эта операция удалит все устройства навсегда, действительно хотите продолжить?',
      deletes_tips:'Эта операция удалит устройства навсегда, действительно хотите продолжить?',
      empty_tips:'Пожалуйста, выберите устройства для удаления',
      /*20170731新加*/
      excel_tips:'Можно загрузить только файл Excel не более 10M',

    },
    OtaList:{
      lock_num:'Версия заблокирована',
      lock_tips:'Хотите разблокировать OTA?',

    },
    terRisk:{
      fkpz:'Настройка управления рисками',
    }
  },
  account:{
    delete_tips:'Действительно хотите удалить этого пользователя?',
  },

  // edit mao
  mao_global: {
    btn: {
      sort: "сортировать",
      e: "Операция",
      cancel: "Отмена",
      add: "Добавить",
      edit: "Изменить",
      submit: "Отправить",
      update: "Изменить",
      delete: "Удалить",
      ok: "Подтверить",
      selectAll: "Выберите все",
      unSelectAll: "Снять все выделение",
      reset: "Сброс",
      createNow: "Отправить",
      confirmUpdate: "Действительно хотите изменить?"
    },
    tip: {
      text: "Приглашение",
      confirmDelete: "Действительно хотите удалить?",
      examine: "Обзор",
      pleaseSelect: "Пожалуйста, выберите",
      pleaseInput: "Пожалуйста, введите",
      search: "Запрос",
      notBlank: "Не может быть пустым",
      success: "Успешно",
      fail: "Ошибка",
      notPassExamine: "Отклонено",
      groundsForRefusal: "Пожалуйста, введите причину отказа",
      notReset: "Восстановление после удаления невозможно"
    }
  },
  /*菜单*/
  menu: {
    home: "Главная",
    terManage: "Устройство",
    terManageSub: {
      myTer: "Мое устройство",
      breakup: "Сделать резервную копию",
      lockOTA: "Заблокировать терминал",
      map: "Карта",
      log: "Лог",
      addTer:"Добавить устройства",
      detailTer:"Подробности терминала",
      riskInfo:"Информация об управлении рисками",
      runLog:'Текущий лог',
      appList:'Список приложений',
      appInstall:'Установка приложений',
      otaLock:'Блокировка OTA',

    },
    advertManage: "Реклама",
    advertManageSub: {
      list: "Список",
      examine: "Обзор",
      examineVideo: 'Видео',
      examineDetail: "Детали обзора",
      edit: "Изменить рекламу",
      editVideo: 'Изменить рекланое видео',
      detail: "Детали рекламы",
      vlist: "Видео реклама",
      vverify: "Видео обзор",
      addVideo: "Добавить рекламное видео",
      dfVList: "Список видео по умолчанию",
      addDfVideo: "Добавить видео по умолчанию"
    },
    appManage: "Приложения",
    appManageSub: {
      list: "Список приложений",
      market: "Магазин приложений",
      custom: "Добавить к моим настройкам",
      viewApp: "Посмотреть приложений",
      customPush: "Пользовательская загрузка",
      appPush: "Загрузка приложения",
      appBind: "Привязать терминал к приложению",
      examine: "Обзор приложения",
      verifyApp: "Посмотреть приложение",
      appEdit: 'Изменить приложение',
      appDetail: 'Детали приложения',
      uploadNew: 'Загрузить новую версию',
      uploadApp: 'Загрузить приложение'
    },
    //20170807 add
    safeManage: "Безопасность",
    safeManageSub:{
      certificate:"Список серитфиктов",
      certNew:"Создать сертификат",
      remote:"Удаленная авторизация",
      certUpload:"Загрузить серитфикат производителя",
      certDetail:"Детали сертификата",
      cerUpload:"Загрузить сертифкат",
      myCert:'Мой сертификата'
    },
    taskManage: "Задачи",
    taskManageSub: {
      list: "Загрузка задач",
      detail: "Детали загрузки задач",
      listHis: "Загруженные задачи",
      detailHis: "Детали загруженных задач"
    },
    dataManage: "Данные",
    dataManageSub: {
      channel: "Торговая организация",
      factory: "Производитель",
      terClassify: "Тип устройства",
      terNum: "Модель устройства",
      advertClassify: "Тип рекламы",
      appClassify: "Тип приложения",
      newChannel: "Добавить торговую организацию",
      editChannel: "Изменить торговую организацию",
      newFirm: "Добавить производителя",
      editFirm: "Изменить производителя"
    },
    railManage: "Управление рисками",
    railManageSub: {
      penSetting: "Установить ограждение",
      warnSetting: "Информация о предупреждении",
      riskDetail:"Детали ограждения",
    },
    sysManage: "Система",
    sysManageSub: {
      romul: 'Загрузить OTA',
      romed: 'Изменить OTA',
      romOTA: "Список OTA",
      examine: "Обзор OTA",
      push: "Загрузить OTA",
      order: "Пользоавательская система",
      animation: "Пользовательская анимация при загрузке",
      animateCustom: "Пользовательская анимация",
      animatePush: "Загрузка анимации",
      pushHistory: "История загрузки",
      firmwareManage: 'Список прошивок',
      firmwareUpload: 'Загрузить прошивку',
      firmwareEdit: 'Изменить прошивку',
      firmwareCheck: 'Обзор прошивки',
      firmwareCheckDt: 'Детали прошивки',
      firmwarePush: 'Загрузка прошивки',
      firmwarePushDevice: 'Загрузка прошивки на устройства',
      launchManage: 'Список загрузчиков',
      launchCheck: 'Проверить загрузчик',
      launchEdit: 'Изменить загрузчик',
      launchNewVer: 'Загрузить новую версию загрузчика',
      verifyLaunch: 'Проверить загрузчик',
      addLaunch: 'Добавить загрузчик',
      launchDetail: 'Детали загрузчика',
      launchPush: 'Загрузить загрузчик',
      launchPushTer: 'Загрузить загрузчик на терминал',
    },
    setManage: "Настройки",
    setManageSub: {
      role: "Список ролей",
      system: "Системная конфигурация",
      menu: "Список меню",
      logo: 'Настройки логотипа'
    },
    accManager: "Учетная запись",
    accManagerSub: {
      account: "Информация об учетной записи",
      subAccount: "Вложенная учетная запись",
      addAccount:'Добавить вложенную учетную запись',
      editAccount:'Изменить вложенную учетную запись',
    },
    menuEdit: 'Редактирование меню'
  },
  /*菜单 END*/
  /*广告*/
  advert: {
    status: "Состояние",
    addAdvert: "Новая реклама",
    deleteAll: "Пакетное удаление",
    all: "Все",
    refusal: "Объясните причину",
    app: "Приложение",
    appSub: {
      name: "Имя",
      classify: "тип",
      uploadTime: "Время загрузки",
      version: "Номер версии"
    },
    isPass: "Результат",
    pass: "Подтверждено",
    notPass: "Отклонено",
    waitOne: "Ожидает отправки",
    waitTwo: "Ожидает рассмотрения",
    addDate: "Добавить время",
    addUser: "Добавившие",
    appName: "Имя приложения",
    img: "Изображение",
    name: "Имя",
    classify : "Тип",
    position : "Размешение",
    positionSub: {
      banner: "Главный баннер",
      starPage: "Стартовая страница"
    },
    jumpType: "Перенаправление",
    jumpTypeSub: {
      net: "Веб-страница",
      appStore: "Магазин приложений"
    },
    url: "URL",
    channel: "Торговая организация",
    ableDate: "Время истечения",
    beginDate: "Время начала",
    endDate: "Время окончания",
    contentImg: "Содержимое",
    reset: "Сброс"
  },
  /*广告 END*/
  /*首页*/
  index: {
    t: "",
    more: "Больше",
    terStatus: "Профиль устройства",
    onlineTer: "Устройства в сети",
    offLineTer: "Отключенные устройства",
    warnTer: "Устройства с предупреждениями",
    taskList: "Список задач",
    pullApp: "Выпуск приложения",
    romUpdate: "Обновление ROM",
    pullAdvert: "Загрузка рекламы",
    infoList: "Список информации",
    riskWarn: "Предупреждение от управления рисками",
    breakWarn: "Предупреждение о сбое"
  },
  /*首页 END */

  /*配置管理*/
  menuConfig: {
    menu: {
      addMenu: "Добавить родительское меню",
      addMenu2: "Добавить меню",
      refreshMenu: "Обновить меню",
      menuName: "Назваине меню",
      selectModel: "Пожалуйста, выберите модуль",
      orderBy: "Сортировать серийные номера",
      notBlankName: "Имя не может быть пустым",
      editMenu: "Изменить меню",
      editSuccess: "Изменино успешно",
      addSubMenu: "Добавить подменю",
      relUrl: "Относительный путь"
    },
    // 配置管理 - 角色管理 Configuration management - Роль management
    role: {
      addRole: "Добавить роли",
      no: "Номер",
      name: "Имя",
      mark: "Описание",
      model: "Модуль",
      updatePermission: "Изменить разрешения",
      editRole: "Изменить роль",
      notBlankName: "Имя не может быть пустым",
      updateSuccess: "Обновлено успешно",
      deleteSuccess: "Удалено успешно",
      modelSelect: "Выберите модуль",
      addSuccess: "Добавлено успешно"
    }
  },
  /*配置管理 end*/
  /* 任务管理 */
  /* add by sing, 2017-10-26 */
  taskTypeNames: {
    ALL: "Все типы",
    APP: "Прилжение",
    OTA: "OTA",
    ROM: "ROM",
    FIRMWARE: "Прошивка",
    AD: "Реклама",
    STARTUP_ANIMATION: "Начальная анимация",
    SHUTDOWN_ANIMATION: "Анимация при выключении",
    STARTUP_SHUTDOWN_ANIMATION: "Вся анимация",
    LOGO: "Логотип",
    LAUNCHER: "Загрузчик",
    WALLPAPER: 'Обои'
  },

  app_adname: 'Имя рекламы',
  app_allpush: 'Загрузить все',
  app_fipush: 'Загрузить файл импорта',
  app_isjtoviewtd: 'Вы перешли в детали задач чтобы отслеживать прогресс загрузки',
  app_mgsys: 'Доменное имя системы управления',
  app_edcode: 'Код авторизации обслуживания',
  app_sapp: 'Пожалуйста, выберите приложение',
  app_spic: 'Пожалуйста, выберите каритнку',
  app_iappnamesrch: 'Пожалуйста, введите имя запроса приложения',
  app_alltyps: 'Все типы',
  app_allpp: 'Все позиции воспроизведения',
  app_addur: 'Время рекламы',
  app_vsize: 'Размер видео',
  app_addtime: 'Добавить время',
  app_psverify: 'Аудит пройден',
  app_vpreview:'Предварительный просмотр видео',
  app_cstandt: 'Длительность выбора и число повторений',
  app_additv: 'Добавить продолжительность',
  app_vdofile: 'файл видео',
  app_filename: 'Имя файла',
  app_vdodur: 'Продолжительность видео',
  app_clreulvdo: 'Нажмите для повтроной загрузки видео',
  app_adddfvdeoad: 'Добавить рекламное видео по умолчанию',
  app_addps: 'Дополнения',
  app_pltimes: 'Число воспроизведений',
  app_pldur: 'Продолжительность воспроизведения',
  app_csvldate: 'Выбор периода валидности',
  app_advdoad: 'Добавление рекламых видео',
  app_mgdfvdo: 'Управление видео по умолчанию',
  app_adstatus: 'Статус рекламы',
  app_addadtype: 'Новый тип рекламы',
  app_newapptype: 'Новый тип приложения',
  app_addmodel: 'Новая модель',
  app_newdvtype: 'Новый тип устройства',
  app_addfmname: 'Новое имя производителя',
  app_srpush: 'Подтверждение загрузки',
  app_ulfile: 'Загружаем файлы',
  app_ttpsddvnum: 'Загрузка завершилась на устройствах',
  app_srsktsdv: 'Вы хотите пропустить эти устройства',
  app_cvpush: 'Покрытие загрузки',
  app_skpush: 'Пропустить загрузку',
  app_pssuccess: 'Загрузка успешна',
  app_nowjump: 'Перейти немедленно',
  app_bcrecov: 'Пакетное уменьшение',
  app_skintro: 'краткое',
  app_addlc: 'Добавить загрузчик',
  app_ulinsfile: 'Загрузить установочные файлы',
  app_clreul: 'Нажмите для повторной загрузки',
  app_lcname: 'Имя загрузчика',
  app_rsfivemin: 'Автоматически обновлять каждые 5 минут',
  app_suresm: 'Подтверждение отправки',
  app_udfiletype: 'Тип загружаемого файла',
  app_plsltype: 'Пожалуйста, выберите тип',
  app_adnamenotnull: 'Имя рекламы не может быть пустым',
  app_plslchannel: 'Пожалуйста, выберите канал поставщика',
  app_plslplpos: 'Пожалуйста, выберите позицию воспроизведения',
  app_slsttime: 'Пожалуйста, выберите время начала',
  app_slendtime: 'Пожалуйста, выберите время окончания',
  app_addsc: 'Добавление успешно',
  app_vlsuccess: 'Аудит успешен',
  app_opsuccess: 'Операция завершилась успешно',
  app_srpassvf: 'Подтверить прохождение аудита',
  app_addvdoad: 'Добавление рекламных видео',
  app_edvdoad: 'Редактирование рекламных видео',
  app_sllimit: 'Выберите период валидности',
  app_srmuldel: 'Подтверить пакетное удаление',
  app_sttcanlateendtime: "Время начала не может быть позже времени окнчания",
  app_etcanelsttime: 'Время окнчания не может быть раньше времени начала',
  app_srdelpush: 'Подтверить удаления загрузки',
  app_srrecovsysdf: 'Не забудьте восстановить систему по умолчанию',
  app_rdless: 'Радиус ограждения меньше чем',
  app_srban: 'Подтверждение не пройдено',
  app_banandrs: 'Не пропустили? Пожалуйста, введите причины непрохождения',
  app_trjmap: 'Карта перемещения',
  app_psdonelftip: 'Имеется {num} устройств которые обновляются или обновились во время этой загрузки. Вы хотите пропустить эти устройства',
  app_psscandtip: 'Установка завершена успешно',
  app_csulpicbsis: 'Нажмите для загрузки картинки, лучший размер для отображения:',
  app_srch: 'Поиск',
  app_lkdevice: 'Найти устройства',
  app_app: 'приложение',
  app_firmw: 'прошивку',
  app_refresh: 'обновить',
  app_sleep: 'Ожидание',
  app_ccdown: 'Отмена скачивания',
  app_iscancelPush: 'Хотите отменить загрузку?',
  app_fmVerIillegal: 'Номре версии неправильный, это должен быть номер, например 1.0.0',
  app_verror: 'Ошибка версии',
  app_other: 'другое',
  app_inssuccess: 'Успешная установка',
  app_tipterop: 'Прилашение операции терминала',
  app_autocmpl: 'Автозаполнение',
  app_noresetfs: 'Бягучы стан прылады на заводзе-вытворцы, звярніцеся да адміністратара Ачысціць',
  app_saleSt: 'Исходящее состояние',
  app_actst: 'Состояние активации',
  app_insfail: 'Сбой установки',
  app_checksignfail: 'Сбой проверки',
  app_srchcontent: ' Поиск содержимого ',
  app_account: 'счета ',
  app_opecontent: 'содержание работы ',
  app_opetime: 'время работы ',
  app_frzaccount: ' лед  узел  счета ',
  app_operator: 'операции  человек ',
  app_userip: ' пользователей  IP ',
  app_deskwp: 'Обои',
  app_channelmcdetail: 'каналы операторов  детали ',
  app_channellevel: 'канал бизнес  класса ',
  app_cermanage: 'сертификат управления ',
  app_lineimportcer: ' линия производства  импортировать  сертификат ',
  app_devicemanage: 'устройство управления ',
  app_fileimportdevice: 'Файл Импорт  оборудования ',
  app_lineimportdevice: ' линия производства  импортировать  оборудование ',
  app_prodmodel: 'вид продукта ',

  app_plimportcer: 'линия производства  импортировать  сертификат клиента ',
  app_importslorder: 'импорт  отдельных  заказов ',
  app_importslcustomer: 'импорт  отдельных  клиентов ',
  app_customername: 'имя клиента ',
  app_orderno: 'Постановление № ',
  app_orderfinishdate: ' дата  выполнения заказа ',
  app_customerno: 'Кодировка  клиента ',


  app_debuginfo: 'отладочной информации ',
  app_adbstatus: ' АБР  государства ',
  app_on1: 'открыть ',
  app_off1: 'закрыть ',
  app_devicemode: 'оборудование  режим ',
  app_normalmode: 'нормальный режим ',
  app_debugmode: 'режим отладки ',
  app_signstatus: ' Состояние  проверки  подписать ',
  app_catchlog: ' захват  журнал ',
  app_tobenimportdv: 'предстоящего  импорта  оборудования',
  app_lineimporttip: ' пожалуйста,настройки  типа оборудования,поставщиков  базовых данных,моделей,адрес и т.д',
  app_cannotwithsysapp: 'не может содержать  системы применения ',
  app_locktime: 'время блокировки ',

  app_risksetting: ' ветер контроля  настройки ',
  app_lockinfo: ' блокировка  информации ',

  app_riskdetail: 'детали  раннего предупреждения ',
  app_lockcity: 'замок  города ',
  app_locklngandlat: 'блокировка  широта и долгота ',
  app_lockstate: 'блокировка  описание ',
  app_bindenclosure: ' обязательного  ограждения ',
  app_unbindenclosure: 'решение  связать  забор ',
  app_sureunlock: 'подтверждение  разблокировать ',
  app_plsinputimgfile: ' Пожалуйста, загрузите  img  формат файла ',
  app_animatefile: 'анимационные файлы ',
  app_misstokentip: 'потери  логин,  нужно  снова войти в систему  разрешения ',

  app_bglock: 'замок в фоновом режиме ',
  app_request: 'уже  заявки ',
  app_unrequest: 'не применяется ',

  app_lockdevice: 'блокирующее устройство ',
  app_pusheddvlist: 'Удаление приложения',
  app_appuninstall: 'применение  разгрузки ',

  app_unlocked: 'Разблокировать ',
  app_unlockdevice: 'Разблокировать  оборудования ',

  app_pushnumcantfive: 'Тужься  , количество  не может превышать  5 ',
  app_selectedappshoupass: 'Установите  применение, должны  в рамках ревизии ',

  app_adRefreshfreq: 'частота обновления  рекламы ',

  app_uninsfail: ' Не удалось удалить ',
  app_uninssc: 'успешно Удалить ',
  app_preversion: 'базовый вариант ',
  app_rdneedmore: 'нужно  больше, чем  забор  радиус ',

  app_addstfile: 'Добавить  файл конфигурации ',
  app_filetag: 'идентификатор файла ',

  app_filestss: 'описание конфигурации ',
  app_uploadfilest: ' загрузить  файл конфигурации ',
  app_excludeapp: 'исключает  применение ',
  app_reupload: 'Загрузить  заново ',
  app_excludefsttip: ' нажмите  Добавить  , чтобы исключить  применение  Введите  имя пакета  ,  полное применение  этой  точки  Enter  исключает  применение  всех  ,  по умолчанию  поддерживает  этот файл  конфигурации  приложений  могут  использовать этот  идентификатор ',

  app_limitxml: 'предел  XML - файл ',
  app_configfile: ' файл конфигурации ',

  app_udversion: 'обновление  версии ',

  app_udsamexml: ' Только  обновления  же  логотип  XML ',
  app_udxmllowertip: 'обновление  версии  версии  будет  ниже, чем  сейчас  ,  в  записи в истории  , как представляется,  не  отображается в  списке ',

  app_childacmg: ' Зи  счета  управления ',

  app_unldvwftip: 'это оборудование  【{wl}】  обязательного  забор  ,  связаны  ли  также исключить  ? ',

  app_udmode: 'режим обновления ',
  app_append: 'Добавить ',


  /*** 非智能设备管理 */
  app_importapp: 'Импортировать  применение ',
  app_adddate: 'Добавить дату ',
  app_addtask: ' Добавить задачу ',
  app_addtesttask: 'Добавить задачу  испытания ',
  app_appdesc: ' применение  описание ',
  app_srcdesc: 'описания ресурсов ',
  app_downapp: 'загрузки приложения ',
  app_downfile: 'загрузить файл ',
  app_addsrc: 'Добавить  ресурсов ',
  app_importsrc: 'Импорт ресурсов ',
  app_srcname: 'имя ресурса ',
  app_srcver: 'ресурсов  версии ',
  app_downsrc: 'загрузки ресурсов ',
  app_number: 'номер ',
  app_softinfo: 'программное обеспечение  информации ',
  app_allstatus: 'все  государства ',
  app_mstype14: 'применение  Кодекса радикальные  Push  пистолет ',
  app_mstype15: 'Кодекс спрятать  пистолет  файл ресурсов  Push ',
  /*** end */


  app_filedesc: 'Файл  описания ',
  app_filetype: 'тип файла ',
  app_subtype: 'подтип ',
  app_addfile: 'Добавить файл ',
  app_stmgpsw: 'пароль  конфигурации  управления',
  app_mapsl: 'карты  выбор ',
  app_bdmap: 'Baidu  карты ',
  app_map: 'карты ',
  app_right: 'разрешение ',
  app_addconfig: 'Добавить конфигурации ',
  app_editconfig: 'Настройка редактора ',
  app_mgpsw: ' управление  пароль ',
  app_dvconfiglist: 'Настроить  список устройств ',
  app_appconfigst: 'Настроить  применение государством ',
  app_applytime: 'Использование  времени',
  app_secrname: ' имя  ключа ',
  app_secrdesc: 'ключ  описание ',
  app_addsecrrule: ' правила  добавить  ключ ',
  app_editsecrrule: 'Редактор  правил  ключа ',
  app_secrdvlist: 'ключ  список устройств ',
  app_secrupdatest: ' ключ  обновления статуса ',
  app_waitupdate: ' обновляться ',

  app_addrandport: 'адрес  и  порт ',
  app_filepath: 'путь к файлу ',
  app_queryudfre: 'частота обновления  запроса ',
  app_lcupload: ' местные загрузить ',
  app_hour: 'час',
  app_addofcloud: ' добавка в облаках ',
  app_bglist: ' Список задней части ',
  app_cntype: 'способ соединения ',
  app_codegunsrc: ' ресурсы для подметания оружия ',
  app_rtosgunsrc: 'Ресурсы ртос',
  
  
  app_rots_1:"Прикладной app",
  app_rots_2:"ресурсы",
  app_rots_3:"Sys системы",
  app_rots_4:"Версия sp с прошивкой чипа безопасности",
  app_rots_5:"Управляемая версия mt",

  app_partpkg: 'добавочный пакет ',
  app_codegunapp: ' подметание пистолета ',
  app_starttime: 'начало времени ',

  app_oilmcsrc: 'ресурсы для заправочных машин ',

  app_downtpl: 'Загрузка шаблонов ',

  app_plsstype: 'Пожалуйста, выберите подтип, пожалуйста. ',

  app_allstyps: 'весь подтип ',

  app_ftooltip: ' мультимедийная картинка / LGA ',

  app_appendpush: 'дополнительная доставка ',

  app_ipitonlylgchar: ' входной элемент может быть только законным символом, таким как английский и нижний. ',

  app_enable: 'Включить ',

  app_spfileis: 'файл поддерживается в формате ',

  app_cnsetting: 'Параметры соединения ',


  app_newtask: 'новое задание ',
  app_adddv: 'Добавить оборудование ',
  app_fileinsst: 'Настройка установки файлов ',
  app_insscautoop: 'автоматическое открытие установки ',
  app_pushsctipins: 'отдавать успешные подсказки ',
  app_total: ' Общая сумма ',
  app_wait: 'ожидание ',
  app_pushing: 'подтолкнуть ',
  app_pushsldev: ' подтолкнуть выбранное устройство ',

  app_repushdv: 'перекладывать не поражение ',
  app_outputdv: 'производное устройство ',

  app_udtime: 'Время обновления ',
  app_surepsxdv: 'подтверждение  push -  {num}  оборудование ',

  app_apppush: 'подача приложения ',
  app_fmwpush: 'прошивки  Push ',
  app_advpush: 'рекламная подача ',
  app_onampush: 'подтолкнуть с начала ',
  app_offampush: 'посадка на выключение ',
  app_onoffampush: 'Анимация выключателя ',
  app_onlgpush: 'Открытие локомотива ',
  app_wppush: 'обои подтолкнут. ',
  app_stfpush: 'файл конфигурации  Push ',
  app_codemc: 'очиститель кода ',
  app_codemcsrc: 'Сканеры  ресурсов ',
  app_sysud: 'Обновление системы ',
  app_fmwud: 'обновление твердого тела ',
  app_anmud: 'обновление картинки ',
  app_qcgunsrcps: 'подметание пистолета ',
  app_iscltask: 'определить отмену задания ',
  app_resrc: 'ресурсы ',
  app_srcfileps: 'файл ресурсов ',
  app_fmVerIillegal1: ' номер версии не является законным, это должно быть с вв и цифрами, например, v1.0. 0',

  app_helptip: 'напоминание о помощи ',
  app_newpsetnewver: 'новое издание TMS оттолкнуло к функциональному входу ',
  app_newptdetail: '  после того, как будет передано функциональное изменение, пользователю нужно будет подтолкнуть на странице задания (Управление → заданием), нажмите на новую задачу, введите имя задания и выберите файл, который нужно отправить. ',
  app_newptdetail1: '	после того, как новое задание будет выполнено, он автоматически выпрыгнул из задания. пользователь мог бы добавить оборудование в несколько раз. мы рекомендуем пользователю отправить небольшое количество оборудования перед большой партией.  провожать. ',

  app_daterange: 'интерпретация даты ',
  app_olinepday: 'ежедневное количество онлайн ',
  app_onlineavgt: ' средний интервал онлайн ',
  app_devicewhe: 'распределение оборудования ',
  app_statistic: 'статистика ',
  app_today: 'сегодня ',
  app_thisweek: 'Эта неделя ',
  app_thismonth: 'в этом месяце ',

  app_addblfile: 'Добавить документ с черным списком ',
  app_blacklsname: 'название черного списка ',
  app_editblls: 'редактирование черного списка ',
  app_blsdesc: 'описание черного списка ',
  app_blsdvlist: 'Список оборудования для черного списка ',

  app_wldesc: 'описание ограждения ',
  app_filectncr: 'файл не является правильным ',

  app_khour: 'время ',
  app_kday: 'день ',
  app_yesterday: 'вчерашний',
  app_rc15d: 'последние 15 дней ',
  app_rc30d: 'последние 30 дней ',
  app_stinfo: 'Информация о состоянии ',

  app_croln: 'текущий онлайн ',
  app_crslp: 'текущий спящий ',
  app_croff: 'текущий уход ',
  app_lstol: 'последнее время онлайн ',
  app_lstsl: ' время последнего сна ',
  app_lstof: 'последнее время выхода ',
  app_limitiplg: 'ограничивать вход в систему IP. ',
  app_illegal: 'незаконность ',
  app_limitiptip: ' Пожалуйста, введите пункт IP, который должен быть ограничен и не вводит ограничения. ',
  app_unknow: 'Неизвестный ',
  app_hisstatus: 'историческое состояние ',
  app_allowiplg: 'Разрешить вход в систему IP ',
  app_allowiptip: ' Пожалуйста, введите разрешенный IP, а не вводите IP - доступ. ',
  app_active1: 'оживление ',
  app_unuse: 'не включено ',
  app_addpsg: 'добавить проход',
  app_psgname: 'Название канала ',
  app_authstat: ' режим разрешения ',
  app_cbackad: 'обратный адрес ',
  app_bsrqsadwl: 'Список адресов бизнес - запроса ',
  app_appwtls: 'Список приложений ',
  app_addapppgkn: 'Добавить список приложений ',
  app_authopen: 'Открытие для открытия ',
  app_authclose: 'разрешение на закрытие ',
  app_addaddr: 'Добавить адрес ',
  app_developer: 'Разработчик ',
  app_editpasg: ' редактировать проход ',
  app_usertype: 'Тип пользователя ',
  app_generate: 'Образование ',
  app_gentip: ' после того, как перерабатывает апплет, первоначальный апплет будет недействительным и не может продолжать подключиться к открытой платформе.  Было ли установлено, что перерабатывает апплет? ',
  app_open1: 'запуск ',
  app_hide: 'Скрыть ',
  app_subtask: 'подзадача ',
  app_sltstype: 'Выберите тип задания ',
  app_command: 'команда',
  app_addsubts: 'Добавить подзадачу ',
  app_commtype: 'тип директивы ',
  app_taskpros: 'график работы ',
  app_cursubts: 'текущая подзадача',
  app_commpush: 'подача команд ',
  app_dvrestart: 'перезапуск оборудования ',
  app_recvorgst: 'восстановление установки на заводе ',
  app_recvanimt: 'восстановительная анимация ',
  app_dvlock: 'устройство блокировки оборудования ',
  app_dvunlock: 'заблокирование оборудования ',
  app_inbdside: 'уже до границы. ',
  app_subtsnum: 'количество подзадач ',
  app_tscrtime: 'время создания задачи ',
  app_ing: 'в середине ',
  app_core: 'ядро ',
  app_filesys: 'Файловая система ',
  app_commd1fw: ' Модуль 1 модуля связи ',
  app_commd2fw: ' Модуль 2 модуля связи ',
  app_readcfw: 'стержень для считывания карт ',
  app_pswkbfw: 'крепление пароля ',
  app_scanhfw: ' сканирование головки для сканирования головки ',
  app_actpossp: 'Активировать диалекту Pos ',
  app_natpossp: 'закрытие разговора POS ',
  app_setcallf: 'Настройка функции разговора ',
  app_clupappdt: 'очистка данных приложения ',
  app_isclupappdt: 'определение данных для расчистки ',
  app_impdistbt: ' Импортирующий канал ',
  app_impmctip: ' Оставайтесь на доске, только поддерживайте excel и не более 10 м. ',
  app_callfunc: 'функция разговора ',

  app_protocal: 'соглашение ',
  app_prtsltip: ' при выборе веб - веб - сайта необходимо гарантировать, что интерфейс поддерживается этим соглашением. ',
  app_rgsvpm: ' уполномоченные параметры службы ',
  app_rgsvip: 'уполномоченный сервисный IP ',
  app_bgntpm: 'Параметры уведомления ',
  app_bgntip: 'записать IP ',
  app_port: 'порт',
  app_flexist: 'Файл уже существует ',
  app_cerid: 'отпечаток пальца ',
  app_wallpaper: 'обои ',

  app_forceins: 'принудительная установка ',
  app_autorun: 'автоматическая работа ',
  app_cusins: 'монтажный монтаж ',
  app_cusuins: 'загруженная выгрузка ',
  app_forcerun: ' принудительное исполнение ',
  app_pushtest: 'тестовый тест ',
  app_pltfblt: 'объявление о платформе ',

  app_addblt: 'добавить объявление ',
  app_blttt: 'заголовок бюллетеня ',
  app_readnum: 'количество чтений ',
  app_bltct: 'Содержание бюллетеня ',
  app_pltudrd: 'платформа была обновлена ',
  app_udlog: 'журнал обновления ',
  app_addver: 'добавленная версия ',
  app_pubdate: 'дата публикации ',
  app_updct: 'обновить содержание ',
  app_editblt: ' редактирование бюллетеня ',
  app_editver: 'редактирование версии ',
  app_verupdate: 'обновление версии ',
  app_clviewdt: 'Нажмите для просмотра подробностей. ',
  app_viewmore: 'Посмотри на это. ',
  app_comptime: 'время компиляции ',
  app_insafnorun: 'неавтоматический запуск после установки ',
  app_normalins: 'обычный монтаж ',
  app_normalunins: 'обычная разгрузка ',
  appp_tipoperate: 'Подсказка для подсказки ',
  app_onlyprov: ' избрать только провинцию ',
  app_filepush: 'файл ',
  app_region: 'область ',
  app_srcmechan: 'производитель поиска по ключевому иероглифам ',
  app_ckcode: 'код проверки ',
  app_cantuins: 'невыгруженная загруженность ',
  app_ippkgname: 'Введите имя пакета',
  app_onlypicfm: ' только файлы формата изображений (JPG, PNG, GIF...) ',
  app_fludlist: 'Обновить список файлов ',
  app_param: 'Параметры ',
  app_catching: 'пойман',
  app_ulding: 'загружается',
  app_ulyet: 'Загрузка завершена',
  app_endcatch: 'закончить захват ',
  app_iscatch: ' установить начало захвата ？',
  app_opterinfo: 'Экспорт терминальной информации',
  app_bcopterinfo: 'пакетный экспорт информации',
  app_cpttime: 'время отсечки ',
  app_eqcapture: 'экран устройства ',
  app_scapture: 'ширма ',
  app_surestcap: 'установить снимок экрана ？',  
  app_lokscrn: "блокирующий экран",
  app_ulkscrn: "откройте экран",
  app_appautrn: "приложение самоактивируется",
  app_perms: 'Единица: миллисекунды',
  app_wattime: 'Время ожидания.',
  app_lcswitch: 'переключение Launcher ',
  app_appadv: 'прикладная реклама ',
  app_cardno: 'номер карточки',
  app_trdno: 'поточный номер',
  app_batcno: 'номер партии',
  app_amout: 'сумма',
  app_mechno: 'коммерческое предприятие',
  app_trdtime: 'время операции',
  app_trddate: 'дата сделки',
  app_trdcore: 'основной поток',
  app_expno: 'справочный номер',
  app_trdtype: 'тип операции',
  app_rectime: 'время записи',
  app_fpaddrs: 'портретный адрес',
  app_propcut: 'пропорциональное обрезание ',
  app_getcash: 'получение текущего',
  app_lctrans: 'перевод строки',
  app_obtrans: 'перевод строки ему',
  app_coretrans: 'основной поток',
  app_tradeNo: 'номер сделки',
  app_export: 'производный ',
  app_ctrc: 'устройство считывания карт с магнитными полосами',
  app_icrc: 'ICCA считыватель карт',
  app_prtst: 'состояние принтера',
  app_pswkb: ' клавиатура пароля',
  app_idfrc: 'устройство считывания удостоверений личности',
  app_led: 'LED',
  app_beep: 'пищик',
  app_codebar: 'штрих - код',
  app_lulog: 'Просмотр журнала',
  app_lust: 'вид состояния',
  app_mdclst: 'модуль вызова статистики',
  app_fcclst: 'метод вызова статистики',

  app_acauth: 'активировать разрешение кода',
  app_authcode: 'код активации',
  app_authrange: 'срок действия программы',
  app_delact: 'временная активация ',
  app_pswtip: 'пароль должен быть больше 8 бит, включая прописные буквы, строчки, цифры и специальные символы ',
  app_phontrs: 'номер телефона ',
  app_mulfcau: '多因子认证',
  app_verifc: '验证',
  app_opmfackip6dycode: '请打开MFA验证器，输入6位动态验证码',
  app_cantprvmcodectadm: '如不能提供多因子认证验证码，请与管理员联系',
  app_lsstep: '上一步',
  app_nxstep: '下一步',
  app_ckidt: '验证身份',
  app_istapp: '安装应用',
  app_bindmfa: '绑定MFA',
  app_ipaclgpsw: '输入账号登录密码',
  app_bindsfdv: '  绑定安全设备',
  app_psfwtsstepop: '请按以下步骤完成绑定操作',
  app_sixnumb: '6位数字',
  app_phdnalyappggidck: '请在手机端下载并安装阿里云APP/Google Authenticator（身份验证器）',
  app_ipappstsagidck: 'iphone：在AppStore搜索阿里云APP/Google Authenticator（身份验证器）',
  app_adappmksagidck: 'Android：在应用市场搜索阿里云APP/Google Authenticator（身份验证器）',
  app_afistclnxitbpagiinx: '安装完成后点击下一步进入绑定页面（如已安装，直接进入下一步）',
  app_usalyagidckscqrc6code: '使用阿里云APP/Google Authenticator（身份验证器）扫描以下二维码，获取6位验证码',
  app_sftkck: '安全令牌验证',
  app_ip6codeubac: '输入6位验证码解除绑定账户',
  app_plipopenalyappoggidckip6dycd: '请在手机中打开阿里云APP或Google Authenticator（身份验证器）,请输入6位动态码',
  app_select_timelist:"Избирательный диапазон времени",
  app_batch_migration:"Массовая миграция",
  app_expired_button:"Срок годности истек за последние 7 дней",
  app_sure_migration:"Подтверждаю миграцию.",
}

export default ru;



// WEBPACK FOOTER //
// ./src/components/language/ru.js